import errorCodes from './errorCodes';

export default class ErrorMapper {
	public static mapToMessage(code: string): string {
		const errorCode = errorCodes.get(code);
		return errorCode ? errorCode.translationKey : 'Error Ocurred';
	}
}
